// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wOU_","col":"styles_col__94Ebo"};